import React, { useState, useEffect } from 'react';
import { HistoryFilter } from 'components/History';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { Box, Grid, Typography } from '@mui/material';
import { InfoCard } from 'sharedComponents/UI';
import { SPARK_ROUTES } from 'constants/routes';
import SparkRunsHistory from 'components/sparkRunHistory/SparkRunsHistory';

type RunsTabProps = { sparkID: string | undefined; onTabClick?: () => void };

function RunsTab({ sparkID = '', onTabClick }: RunsTabProps) {
  const navigate = useNavigate();
  const [historyFilter] = React.useState<HistoryFilter>({
    sparkIDs: [sparkID],
    dateRange: {
      startDate: moment().subtract(1, 'month'),
      endDate: moment(),
    },
  });

  const [onNoSparkRuns, setOnNoSparkRuns] = React.useState(false);
  const [showInfoCard, setShowInfoCard] = useState(false);

  const onViewClick = () => {
    navigate(`${SPARK_ROUTES.HISTORY}?sparkID=${sparkID}`);
  };

  const handleNoSparkRuns = () => {
    setOnNoSparkRuns(true);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowInfoCard(true);
    }, 1100);

    return () => clearTimeout(timer);
  }, []);

  const handleTabClick = () => {
    if (onTabClick) onTabClick();
  };

  return (
    <Grid container gap={1} onClick={handleTabClick}>
      <Grid item width='100%'>
        {showInfoCard && !onNoSparkRuns && (
          <Box sx={{ paddingTop: '8px' }}>
            <InfoCard
              info={
                <>
                  Showing last 5 runs.{' '}
                  <Typography
                    component='span'
                    variant='subtitle2'
                    sx={{
                      fontFamily: 'Mont-Semibold',
                      cursor: 'pointer',
                      textDecoration: 'underline',
                    }}
                    onClick={onViewClick}
                  >
                    View all runs
                  </Typography>
                </>
              }
              cardStyles={{
                borderRadius: '10px !important',
              }}
            />
          </Box>
        )}
      </Grid>
      <SparkRunsHistory
        sparkID={sparkID}
        historyFilter={historyFilter}
        showPaginationControls={false}
        paginatedQuery={{ pageNumber: 1, pageSize: 5 }}
        onNoSparkRuns={handleNoSparkRuns}
      />
    </Grid>
  );
}

export default RunsTab;
